import React from "react";
import "./ColumnContent.scss";

interface Props {
  title?: string;
  description: any;
  imageUrl: string;
}

export function ColumnContent({ title, description, imageUrl }: Props) {
  return (
    <div className={"column-content"}>
      <div className={"left"} style={{ background: `url(${imageUrl})` }} />
      <div className={"right"}>
        {title && <h2>{title}</h2>}
        {description}
      </div>
    </div>
  );
}
